import { z } from 'zod';
import { IsoDateTime, LocalDate, Uuid } from './common.js';
/** Module `feedback` (docs/modules/feedback.md, spec 8.6.9). Owner: task S20. */
export const FeedbackGroupSettings = z.object({
    enabled: z.boolean().default(false),
    /** Minutes after sign-out before the email goes. */
    delayMinutes: z.number().int().min(0).max(10080).default(60),
    /** No more than one feedback email per person (email address) per this many days. */
    minDaysBetween: z.number().int().min(0).max(365).default(30),
    /** Ratings at or below this trigger feedback.low_score (0 = never). */
    lowScoreAtOrBelow: z.number().int().min(0).max(5).default(2),
    /** Empty = i18n default ("How was your visit to {site}?"). */
    question: z.string().max(200).default(''),
    allowComment: z.boolean().default(true),
    subject: z.string().max(200).default(''),
    body: z.string().max(10000).default(''),
});
export const FeedbackTenantSettings = z.object({
    linkDays: z.number().int().min(1).max(60).default(14),
});
/** Public page (`/f/:token`). GET shows; POST records (GET never records, because email scanners follow links). */
export const FeedbackPageView = z.object({
    tenantName: z.string(),
    siteName: z.string(),
    question: z.string(),
    allowComment: z.boolean(),
    /** From `?r=` in the link, for the one-tap emails. */
    preselected: z.number().int().min(1).max(5).nullable(),
    /** Already answered: the answer can be changed for 24 hours. */
    answer: z.object({ rating: z.number().int(), comment: z.string() }).nullable(),
    canChange: z.boolean(),
});
export const FeedbackAnswer = z.object({ rating: z.number().int().min(1).max(5), comment: z.string().trim().max(2000).default('') });
export const FeedbackReportQuery = z.object({
    siteId: Uuid.optional(),
    hostMemberId: Uuid.optional(),
    groupId: Uuid.optional(),
    from: LocalDate,
    to: LocalDate,
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export const FeedbackResponseRow = z.object({
    id: Uuid,
    visitId: Uuid,
    visitorName: z.string(),
    siteName: z.string(),
    hostName: z.string().nullable(),
    rating: z.number().int(),
    comment: z.string(),
    receivedAt: IsoDateTime,
});
export const FeedbackSummaryRow = z.object({
    key: z.string(),
    label: z.string(),
    responses: z.number().int(),
    average: z.number(),
    /** count per rating 1..5 */
    distribution: z.tuple([z.number(), z.number(), z.number(), z.number(), z.number()]),
});
export const FeedbackReport = z.object({
    sent: z.number().int(),
    responses: z.number().int(),
    average: z.number().nullable(),
    bySite: z.array(FeedbackSummaryRow),
    byHost: z.array(FeedbackSummaryRow),
    items: z.array(FeedbackResponseRow),
    total: z.number().int(),
});
//# sourceMappingURL=feedback.js.map